import MainDesign from "../../MainDesign";
import React from "react";

export default function RegulationsKEDPage() {
    return <MainDesign containerStyles="container py-32">
        <div className='mb-4 text-center mw-md-2xl mx-auto'>
            <span className='mb-4 badge bg-success text-white text-uppercase shadow'>
          Regulamin
            </span>
            <h1
                className='font-heading mb-4 fs-5 text-white'
                style={{letterSpacing: '-1px'}}
            >
                Regulamin usługi KED serwisu PRODUKACJA.PL
            </h1>
        </div>
        <div className='mw-md-2xl mx-auto py-3'>
            <p className='fs-9 text-white mb-4'>
                Treść regulaminu usługi KED (kursu efektywnego działania) znajduje się pod <a
                className='link-success text-decoration-underline'
                href='https://produkacja.s3.eu-central-1.amazonaws.com/regulamin/Regulamin+us%C5%82ugi+KED+12.03.25.pdf'>tym
                linkiem</a>.
            </p>
        </div>

        <div className='mt-8 text-center mw-md-2xl mx-auto'>
                <span className='text-success fw-medium'>
                    Ostatnia aktualizacja: 12.03.2025<br/>
                </span>
            <span className='text-secondary-light fw-medium fs-12'>
                    (Zmiany dotyczą tylko nowych użytkowników)
                </span>
        </div>
    </MainDesign>
}